import React from 'react';
import cx from './index.module.scss';

const NotFound = () => {
  return (
    <div className={cx.wrap}>
      <img className={cx.image} src={`${process.env.PUBLIC_URL}/images/image_not_found.svg`} alt=""/>
      <div className={cx.title}>회사를 찾을 수 없습니다</div>
      <div className={cx.description}>참여자 모수가 충분하지 않아<br />결과에서 제외되었습니다.</div>
    </div>
  )
};

export default NotFound;
